// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as DatabaseExtended } from '../../../../../ui-v3/src/assets/icons/extended/entities/database.svg?react';
import { createIcons } from '../../Icon';
const DatabaseIcon = /* @__PURE__ */ createIcons('Database', {
    extended: DatabaseExtended
});
DatabaseIcon.supportedTypes = [
    'extended'
];
DatabaseIcon.category = 'entities';
export default DatabaseIcon;
